import { useTranslation } from "@/components/LanguageContext";

export default function CalendarSection() {
  const { t } = useTranslation();
  const exams = [
    { day: "--", month: "---", title: "Módulos 1-4", location: t("calendar.location"), desc: t("calendar.open"), status: "open", statusLabel: t("calendar.open") },
    { day: "--", month: "---", title: "Módulos 5-8", location: t("calendar.location"), desc: t("calendar.open"), status: "open", statusLabel: t("calendar.open") },
    { day: "--", month: "---", title: "Módulos 9-12", location: t("calendar.location"), desc: t("calendar.soon"), status: "soon", statusLabel: t("calendar.soon") },
  ];
  return (
    <section id="calendario" data-testid="calendar-section" className="py-24 md:py-32 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#00A8FF] mb-2">{t("calendar.label")}</p>
          <div className="section-divider mx-auto mb-6" />
          <h2 className="font-['Outfit'] text-3xl md:text-4xl font-extrabold tracking-tight text-[#0A1628] mb-4">{t("calendar.title")}</h2>
          <p className="text-base text-slate-500 max-w-lg mx-auto">{t("calendar.desc")}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {exams.map((exam, i) => (
            <div key={i} className="bg-white border border-slate-200 rounded-lg p-7 transition-all duration-300 hover:shadow-md hover:border-[#00A8FF]/30" data-testid={`calendar-card-${i}`}>
              <div className="flex items-center gap-4 mb-5">
                <div className="bg-[#0A1628] text-white text-center px-4 py-3 rounded-md min-w-[60px]">
                  <div className="font-['Outfit'] text-xl font-black leading-none">{exam.day}</div>
                  <div className="text-[10px] font-medium text-slate-300 mt-1">{exam.month}</div>
                </div>
                <div>
                  <h4 className="font-['Outfit'] font-bold text-[#0A1628] text-sm">{exam.title}</h4>
                  <p className="text-xs text-slate-400">{exam.location}</p>
                </div>
              </div>
              <p className="text-sm text-slate-500 mb-4 leading-relaxed">{exam.desc}</p>
              <span className={`inline-block text-[11px] font-bold px-3 py-1.5 rounded-full uppercase tracking-wider ${exam.status === "open" ? "bg-[#00A8FF]/10 text-[#00A8FF] border border-[#00A8FF]/20" : "bg-slate-100 text-slate-500 border border-slate-200"}`} data-testid={`calendar-status-${i}`}>{exam.statusLabel}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
